import { Box, Button, useStyleConfig } from '@chakra-ui/react';
import { getBulletRow, openBulletRow } from './utils';
import { RiArrowDownCircleFill } from 'react-icons/ri';

const BulletNav = ({ stateProps }) => {
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  let buttonVariant = {...buttonStyles.bulletRowOpen};
  const firstRowBullets = {};
  const secondRowBullets = {};
  firstRowBullets.recommended = stateProps.bulletData.bullets['recommended'];
  firstRowBullets.fillable = stateProps.bulletData.bullets['fillable'];
  firstRowBullets.generic = stateProps.bulletData.bullets['generic'];
  secondRowBullets.existing = stateProps.bulletData.bullets['existing'];
  secondRowBullets.freeform = stateProps.bulletData.bullets['freeform'];
  if (typeof stateProps.bulletData.bullets['searched'] !== 'undefined') {
    secondRowBullets.searched = stateProps.bulletData.bullets['searched'];
  }
  return (
    <><Box>
      {getBulletRow(firstRowBullets, stateProps, buttonStyles)}
      <Button

        sx={buttonVariant}
        onClick={e => {
          openBulletRow(stateProps);
        }}
      >
        <RiArrowDownCircleFill  /></Button>
    </Box>
      {stateProps.openBulletRow.open &&
        <Box>
          {getBulletRow(secondRowBullets, stateProps, buttonStyles)}
        </Box>
      }
    </>
  );
};
export default BulletNav;


/*



 */